<template>
<div id="cubelogoanimation" :class="{inf}">
	<div class="cube">
		<div class="face face1"><img src="@/assets/logosvg/9.svg" alt=""></div>
		<div class="face face2"><img src="@/assets/logosvg/8.svg" alt=""></div>
		<div class="face face3"><img src="@/assets/logosvg/4.svg" alt=""></div>
		<div class="face face4"><img src="@/assets/logosvg/2.svg" alt=""></div>
	</div>
</div>
</template>

<style scoped lang="sass">
#cubelogoanimation
	width: 30%
	margin: 50px auto
	perspective: 800px
	perspective-origin: center center

	&.inf
		.cube
			animation: rotateCube 2s infinite

.cube
	width: 100%
	aspect-ratio: 1.93
	position: relative
	transform-style: preserve-3d
	animation: rotateCube 2s 1
	animation-timing-function: ease-in-out
	animation-delay: 0.5s
	
.face
	position: absolute
	width: 100%
	height: 100%
	backface-visibility: hidden

.face img
	width: 100%
	height: 100%

	
.face1
	transform: rotateX(0deg) translateY(0%)

.face2
	transform: rotateX(90deg) translateY(0%)

.face3
	transform: rotateX(180deg) translateY(0%)

.face4
	transform: rotateX(-90deg) translateY(0%)

@keyframes rotateCube
	0%
		transform: rotateX(0deg)
	12.5%
		transform: rotateX(90deg)
	25%
		transform: rotateX(180deg)
	37.5%
		transform: rotateX(270deg)
	50%
		transform: rotateX(360deg)
	100%
		transform: rotateX(360deg)
  

</style>

<script>
import {
	mapState
} from 'vuex';

export default {
	name: 'cubelogoanimation',
	props: {
		inf: Boolean
	},
	computed: mapState({
		auth: state => state.auth,
	}),

	methods: {

	},
}
</script>
